<template>
<div class="service-base">
  <div class="service-img" v-if="UrlList">
    <img :src="'https://'+UrlList" alt="" >
  </div>
  <div class="content-title">
      <router-link :to="titles[index].url"
         v-for="(item,index) in titles" :key="index"
      >
        <a
          :class="{current : current == index}"
        @click="click(index,item.url)"
        >{{item.name}}</a>
      </router-link>
  </div>
  <div class="service-content">
    <div class="content-base">
      <keep-alive>
        <router-view>
        </router-view>
      </keep-alive>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: "Service",
  data(){
    return{
      current:1,
      UrlList: null,
      titles:[
        {'name':'服务理念','url':'/service/service_concept'},
        {'name':'联系方式','url':'/service/service_tel'},
        {'name':'培训认证','url':'/service/service_train'},
        {'name':'驱动下载','url':'/service/service_drive'},
        {'name':'操作手册','url':'/service/service_operation'},
        ],
    }
  },
  created() {
    this.GetUrlData()
  },
  methods:{
    click(index,url){
      this.current = index
    },
    GetUrlData(){
      this.$axios.get('/api/photo/getBuildBanana',{params:{
          id:30
        }}).then(res=>{
        this.UrlList=res.data.data[0].photoList[0].address;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.service-base{
  .current{
    color: white;
    background: #188ACB;
    border-radius: 20px;
  }
  .service-img{
    img{
      width: 100%;
      height: 250px;
      object-fit: cover;
    }
  }
  .content-title{
    text-align: center;
    height: 60px;
    a{
      color: black;
      text-decoration: none;
      margin: 30px;
      padding: 2px 8px;
      font-size: 18px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      line-height: 60px;
    }
  }
  .service-content{

    .content-base{
      margin: 0 auto;
      display: flex;
      align-items: center;
      width: 74.5vw;
      height: 850px;
    }
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    background: url('../../assets/service/bg@3x.png') center center / cover no-repeat ;
  }
}
</style>